import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import { Sale } from 'pricing';
import { createSelector } from 'reselect';

import { ApplicationState } from '../../types';

export const selectCurrentPeriod = ({ pricing: { meta } }: ApplicationState) => meta.currentPeriod;

export const selectSale = ({ pricing: { sale } }: ApplicationState) => sale?.data;

const mapPeriodToSale: { [key in SubscriptionPeriod]: keyof Sale } = {
  ANNUAL: 'annual',
  MONTHLY: 'monthly',
  LIFETIME: 'annual'
};

export const selectCurrentSaleCoupon = createSelector(
  selectSale,
  selectCurrentPeriod,
  (sale, period) => sale && sale[mapPeriodToSale[period]]?.coupon
);

export const selectCurrentSaleDiscount = createSelector(
  selectSale,
  selectCurrentPeriod,
  (sale, period) => sale && sale[mapPeriodToSale[period]]?.discount
);

export const selectPricingContent = ({ pricing: { content } }: ApplicationState) => content?.data;

export const selectPricingSubscriptionPlans = ({ pricing: { pricingSubscriptionData } }: ApplicationState) =>
  pricingSubscriptionData?.data?.plans;

export const selectPricingContentError = ({ pricing: { content } }: ApplicationState) => content?.error;

export const selectPricingSubscriptionPlansError = ({ pricing: { pricingSubscriptionData } }: ApplicationState) =>
  pricingSubscriptionData?.error;
